export const fetchTemplates = (options) => (
  {
    type: 'FETCH_TEMPLATES'
  }
)

export const fetchTemplate = ({id, boxId, name}) => {
  return(
  {
    type: 'FETCH_TEMPLATE',
    id,
    boxId,
    name
  }
)
}
export const removeTemplate = (template) => {
  return(
  {
    type: 'REMOVE_TEMPLATE',
    template
  }
)
}

export const saveConfigAsTemplate = (vehicleId, templateName) => {
  return(
    {
      type: 'SAVE_CONFIG_AS_TEMPLATE',
      vehicleId,
      templateName
    }
  )
}

export const applyTemplateToBox = (appliedTemplate, boxId) => {
  return(
    {
      type: 'APPLIED_TEMPLATE_TO_BOX',
      boxId,
      appliedTemplate,
    }
  )
}


